import React, { useState } from 'react';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import './CheckoutPayment.scss';
import { months, years } from './mock-data';
import visa from '../../assets/img/icon/Visa.svg';
import master from '../../assets/img/icon/Master.svg';
import paypal from '../../assets/img/icon/Paypal.svg';
import bottomArrow from '../../assets/img/icon/Bottom-Arrow.svg';

import payment1 from '../../assets/img/checkout-payment/payment-1.png';
import payment2 from '../../assets/img/checkout-payment/payment-2.png';

const CheckoutPaymentSchema = Yup.object().shape({
    delivery: Yup.string().required('Delivery is required'),
    paymentMethod: Yup.string().required('Payment method is required'),
    card: Yup.number()
        .min(1000000000000000, 'Card number is not valid')
        .max(9999999999999999, 'Card number is not valid')
        .required('Card number is required'),
    month: Yup.string().required('month is required'),
    year: Yup.string().required('year is required'),
    ccv: Yup.string().required('CCV is required'),
});

const CheckoutPayment = () => {
    const [isMonthChanged, setIsMonthChanged] = useState(false);
    const [chosenValueMonth, setChosenValueMonth] = useState('');
    const [isYearChanged, setIsYearChanged] = useState(false);
    const [chosenValueYear, setChosenValueYear] = useState('');

    const handleMonthChange = (event) => {
        setIsMonthChanged(true);
        const { value } = event.target;
        setChosenValueMonth(value);
    };

    const handleYearChange = (event) => {
        setIsYearChanged(true);
        const { value } = event.target;
        setChosenValueYear(value);
    };

    return (
        <div className="checkout-payment">
            <div className="container">
                <Formik
                    initialValues={{
                        delivery: '',
                        paymentMethod: '',
                        card: '',
                        month: '',
                        year: '',
                        ccv: '',
                    }}
                    validationSchema={CheckoutPaymentSchema}
                    onSubmit={(values, { setSubmitting }) => {
                        console.log(values);
                        setSubmitting(true);
                    }}
                >
                    {({ isSubmitting, handleChange }) => (
                        <Form>
                            <div className="row">
                                <div className="checkout-payment_left col-12 col-lg-7 pl-0 pr-30px">
                                    <div
                                        className="checkout-payment_left-wrapper mb-5 mb-lg-0 pt-26px pb-26px pl-50px pr-50px"
                                        style={{ border: '1px solid #e7e7e7' }}
                                    >
                                        <div className="checkout-payment_delivery mb-60px">
                                            <div className="font-title size-25 font-weight-bold mb-28px">
                                                Delivery Method
                                            </div>
                                            <div role="group" aria-labelledby="my-radio-group">
                                                <div className="checkout-payment_group mb-20px d-flex">
                                                    <Field
                                                        className="checkout-payment_radio cursor-pointer"
                                                        type="radio"
                                                        id="delivery1"
                                                        name="delivery"
                                                        value="free shipping"
                                                    />
                                                    <label className="line-normal cursor-pointer" htmlFor="delivery1">
                                                        <div className="size-18 color-nero mb-3px">Free Shipping</div>
                                                        <div className="size-14 color-dark-gray-1">
                                                            5-8 business days
                                                        </div>
                                                    </label>
                                                </div>
                                                <div className="checkout-payment_group d-flex">
                                                    <Field
                                                        className="checkout-payment_radio cursor-pointer"
                                                        type="radio"
                                                        id="delivery2"
                                                        name="delivery"
                                                        value="standard shipping"
                                                    />
                                                    <label className="line-normal cursor-pointer" htmlFor="delivery2">
                                                        <div className="size-18 color-nero mb-3px">
                                                            Standard Shipping
                                                        </div>
                                                        <div className="size-14 color-dark-gray-1">
                                                            4-5 business days
                                                        </div>
                                                    </label>
                                                    <div className="line-normal ml-auto size-18 color-black">$3.00</div>
                                                </div>
                                            </div>
                                            <ErrorMessage
                                                className="color-contessa text-left mt-2"
                                                name="delivery"
                                                component="div"
                                            />
                                        </div>
                                        <div className="checkout-payment_payment-method mb-40px">
                                            <div className="font-title size-25 font-weight-bold mb-28px">
                                                Payment Method
                                            </div>
                                            <div className="checkout-payment_group d-flex flex-wrap">
                                                <div className="mr-12px">
                                                    <Field
                                                        className="checkout-payment_radio d-none"
                                                        id="payment-method1"
                                                        type="radio"
                                                        name="paymentMethod"
                                                        value="visa"
                                                    />
                                                    <label
                                                        className="card d-flex justify-content-center align-items-center"
                                                        htmlFor="payment-method1"
                                                    >
                                                        <img src={visa} alt="visa" />
                                                    </label>
                                                </div>
                                                <div className="mr-12px">
                                                    <Field
                                                        className="checkout-payment_radio d-none"
                                                        id="payment-method2"
                                                        type="radio"
                                                        name="paymentMethod"
                                                        value="master"
                                                    />
                                                    <label
                                                        className="card d-flex justify-content-center align-items-center"
                                                        htmlFor="payment-method2"
                                                    >
                                                        <img src={master} alt="visa" />
                                                    </label>
                                                </div>
                                                <div>
                                                    <Field
                                                        className="checkout-payment_radio d-none"
                                                        id="payment-method3"
                                                        type="radio"
                                                        name="paymentMethod"
                                                        value="paypal"
                                                    />
                                                    <label
                                                        className="card d-flex justify-content-center align-items-center"
                                                        htmlFor="payment-method3"
                                                    >
                                                        <img src={paypal} alt="visa" />
                                                    </label>
                                                </div>
                                            </div>
                                            <ErrorMessage
                                                className="color-contessa text-left mt-2"
                                                name="paymentMethod"
                                                component="div"
                                            />
                                        </div>
                                        <div className="checkout-payment_card mb-30px">
                                            <div className="size-16 color-nero mb-12px">CARD NUMBER</div>
                                            <Field
                                                name="card"
                                                placeholder="Card number"
                                                className="checkout-payment_card-input size-16 color-nero pb-18px w-100"
                                            />
                                            <ErrorMessage
                                                className="color-contessa text-left mt-2"
                                                name="card"
                                                component="div"
                                            />
                                        </div>
                                        <div className="checkout-payment_date mb-30px">
                                            <div className="size-16 color-nero mb-12px">EXPIRATION DATE</div>
                                            <div className="row w-100 position-relative m-0">
                                                <div className="checkout-payment_month col-12 col-sm-6 pl-0">
                                                    <Field
                                                        name="month"
                                                        component="select"
                                                        onChange={(e) => {
                                                            handleMonthChange(e);
                                                            handleChange(e);
                                                        }}
                                                        value={chosenValueMonth}
                                                        style={!isMonthChanged ? { color: '#acacac' } : null}
                                                        className="checkout-payment_month-input text-capitalize size-16 color-nero pb-18px w-100"
                                                    >
                                                        <option disabled value="" defaultValue className="mb-20px">
                                                            Month
                                                        </option>
                                                        ;
                                                        {months.map((m, i) => {
                                                            return (
                                                                <option
                                                                    value={m}
                                                                    key={i}
                                                                    className="text-capitalize color-nero"
                                                                >
                                                                    {m}
                                                                </option>
                                                            );
                                                        })}
                                                    </Field>
                                                    <ErrorMessage
                                                        className="color-contessa text-left mt-2"
                                                        name="month"
                                                        component="div"
                                                    />
                                                    <img
                                                        src={bottomArrow}
                                                        alt="bottom arrow"
                                                        className="bottom-arrow position-absolute"
                                                    />
                                                </div>
                                                <div className="checkout-payment_year col-12 col-sm-6 pr-0 ">
                                                    <Field
                                                        name="year"
                                                        component="select"
                                                        onChange={(e) => {
                                                            handleYearChange(e);
                                                            handleChange(e);
                                                        }}
                                                        value={chosenValueYear}
                                                        style={!isYearChanged ? { color: '#acacac' } : null}
                                                        className="checkout-payment_year-input text-capitalize size-16 color-nero pb-18px w-100"
                                                    >
                                                        <option disabled value="" defaultValue className="mb-20px">
                                                            Year
                                                        </option>
                                                        ;
                                                        {years.map((y, i) => {
                                                            return (
                                                                <option
                                                                    value={y}
                                                                    key={i}
                                                                    className="text-capitalize color-nero"
                                                                >
                                                                    {y}
                                                                </option>
                                                            );
                                                        })}
                                                    </Field>
                                                    <ErrorMessage
                                                        className="color-contessa text-left mt-2"
                                                        name="year"
                                                        component="div"
                                                    />
                                                    <img
                                                        src={bottomArrow}
                                                        alt="bottom arrow"
                                                        className="bottom-arrow position-absolute"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="checkout-payment_ccv mb-50px">
                                            <div className="row w-100 m-0">
                                                <div className="col-12 col-sm-6 pl-0">
                                                    <div className="size-16 color-nero mb-12px">CVV</div>
                                                    <Field
                                                        name="ccv"
                                                        placeholder="CVV (3 or 4 digit code)"
                                                        className="checkout-payment_ccv-input size-16 color-nero pb-18px w-100"
                                                    />
                                                    <ErrorMessage
                                                        className="color-contessa text-left mt-2"
                                                        name="ccv"
                                                        component="div"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="checkout-payment-right col-12 col-lg-5 px-0">
                                    <div
                                        className="checkout-payment_product pt-26px pb-60px pl-30px pr-30px mb-20px"
                                        style={{ backgroundColor: '#fafafa' }}
                                    >
                                        <div className="d-flex mb-50px">
                                            <div
                                                className="mr-12px d-flex justify-content-center align-items-center"
                                                style={{ backgroundColor: '#ffffff', width: '120px', height: '120px' }}
                                            >
                                                <img src={payment2} alt="product" />
                                            </div>
                                            <div>
                                                <div className="font-title font-weight-bold size-16 color-nero">
                                                    Convertible Mini Merinal
                                                </div>
                                                <div className="color-black size-16" style={{ fontWeight: 500 }}>
                                                    $1,000.00
                                                </div>
                                                <div className="color-gimblet size-14">{'(1 x $1,000.00)'}</div>
                                            </div>
                                        </div>
                                        <div className="d-flex mb-50px">
                                            <div
                                                className="mr-12px d-flex justify-content-center align-items-center"
                                                style={{ backgroundColor: '#ffffff', width: '120px', height: '120px' }}
                                            >
                                                <img src={payment1} alt="product" />
                                            </div>
                                            <div>
                                                <div className="font-title font-weight-bold size-16 color-nero">
                                                    Convertible Mini Merinal
                                                </div>
                                                <div className="color-black size-16" style={{ fontWeight: 500 }}>
                                                    $2,000.00
                                                </div>
                                                <div className="color-gimblet size-14">{'(2 x $1,000.00)'}</div>
                                            </div>
                                        </div>
                                        <div className="d-flex justify-content-between align-items-center mb-16px">
                                            <div className="color-nero size-16">SUBTOTAL</div>
                                            <div className="color-nero size-18" style={{ fontWeight: 500 }}>
                                                $3,000.00
                                            </div>
                                        </div>
                                        <div
                                            className="d-flex justify-content-between align-items-center pb-18px mb-24px"
                                            style={{ borderBottom: '1px solid #acacac' }}
                                        >
                                            <div className="color-nero size-16">SHIPPING FEE</div>
                                            <div className="color-nero size-16" style={{ fontWeight: 500 }}>
                                                $3.00
                                            </div>
                                        </div>
                                        <div className="d-flex justify-content-between align-items-center mb-16px">
                                            <div className="color-nero size-16">TOTAL</div>
                                            <div className="color-nero size-24" style={{ fontWeight: 500 }}>
                                                $3,003.00
                                            </div>
                                        </div>
                                    </div>
                                    <button
                                        className="checkout-payment_btn text-center w-100 size-14 text color-white text-uppercase"
                                        disabled={isSubmitting}
                                        type="submit"
                                    >
                                        {'CONFIRM & CHECK OUT'}
                                    </button>
                                </div>
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>
        </div>
    );
};

export default CheckoutPayment;
